import { localStorageKeys } from 'config/localStorage/localStorageKeys'
import { useEffect } from 'react'
import { Link } from 'libs/router'
import { useToast } from 'shared/hooks'
import { Me } from 'shared/types/general.types'
import { useTranslation } from 'libs/i18n'

type UsePopulateMeProps = {
	isSuccess: boolean
	data: Me | undefined
	setData: (data: any) => void
}

export const usePopulateMe = ({ isSuccess, data, setData }: UsePopulateMeProps) => {
	const { t } = useTranslation()

	useEffect(() => {
		if (isSuccess) {
			setData((prev: any) => ({ ...prev, user: data }))

			if (localStorage.getItem(localStorageKeys.showBankToast) === 'true' && !data?.payout_method) {
				useToast({
					type: 'error',
					message: (
						<Link to="/profile">{t('Please click here to fill in your payout details')}</Link>
					)
				})()

				localStorage.setItem(localStorageKeys.showBankToast, 'false')
			}
		}
	}, [data, isSuccess])
}
